import BookOpen from "lucide-react/dist/esm/icons/book-open.mjs";
import Library from "lucide-react/dist/esm/icons/library.mjs";
import Search from "lucide-react/dist/esm/icons/search.mjs";
import Settings from "lucide-react/dist/esm/icons/settings.mjs";

export type MobileDestination = "abridged" | "library" | "find" | "settings";

const destinations: Array<{ id: MobileDestination; label: string; icon: typeof BookOpen }> = [
  { id: "library", label: "Library", icon: Library },
  { id: "find", label: "Find", icon: Search },
  { id: "settings", label: "Settings", icon: Settings },
];

export function MobilePrimaryNavigation({ active, onSelect }: {
  active: MobileDestination;
  onSelect: (destination: MobileDestination) => void;
}) {
  return (
    <nav className="mobile-primary-navigation" aria-label="Primary">
      {destinations.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          type="button"
          className={active === id ? "active" : undefined}
          aria-current={active === id ? "page" : undefined}
          onClick={() => onSelect(id)}
        >
          <Icon aria-hidden="true" />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
}
